var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.6673,
    cy: 34.6654,
    r: 25.3333,
    fill: "#E7ECFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2337_15664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 51,
    height: 51
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.6673,
    cy: 34.6654,
    r: 25.3333,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2337_15664)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8403 22.6822C24.4717 25.277 21.3225 26.2327 18.5678 27.2427C15.8136 28.2523 12.7855 30.0678 12.5745 32.9939C12.4422 34.8339 13.5145 36.6121 13.3319 38.4483C12.9551 42.2383 8.00666 43.5128 5.71257 46.5531C4.06169 48.7415 3.94674 51.8672 5.08359 54.3616C6.22045 56.8559 8.46379 58.7367 10.9778 59.8298C16.1665 62.0843 22.4701 61.0558 27.081 57.7779C31.6915 54.5003 34.658 49.2101 35.7387 43.657C36.8194 38.1042 36.1274 32.3107 34.45 26.9079C33.8268 24.901 32.9479 22.786 31.1371 21.7195C29.3266 20.653 26.4097 21.3927 26.0799 23.4681L25.8403 22.6822Z",
    fill: "#0A0F21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6465 27.9016C24.6465 20.5925 30.077 14.668 36.7759 14.668C43.4748 14.668 48.9049 20.5925 48.9049 27.9016C48.9049 35.2102 43.4748 41.1348 36.7759 41.1348C30.077 41.1348 24.6465 35.2102 24.6465 27.9016Z",
    fill: "#0A0F21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0002 25.4924C28.0002 25.4924 25.3897 23.4274 25.4231 22.9688L24.6465 23.2809L27.029 26.2428L28.0002 25.4924Z",
    fill: "#FF05DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8047 62.5169C21.8047 62.5169 31.1394 67.3328 36.2586 67.2153C41.5218 67.0945 52.9519 61.8019 52.9519 61.8019C52.9519 61.8019 50.714 50.1842 38.5584 52.7539C38.5584 52.7539 27.2114 49.9211 21.8047 62.5169Z",
    fill: "#57C6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4443 39.9141L32.8627 41.7099L32.765 54.6363C32.765 54.6363 33.3725 57.9846 38.8438 58.0784C44.0079 58.1668 44.352 54.4821 44.352 54.4821L43.4443 39.9141L27.4922 51.6379Z",
    fill: "#FBDED4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8069 49.0565L32.8627 41.7109L32.8069 49.0565Z",
    fill: "#0A0F21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3495 49.072C33.0046 49.072 32.8086 49.0558 32.8066 49.0554L32.8624 41.7099L43.4439 39.9141L43.7073 44.1443C40.2529 48.6844 35.0315 49.072 33.3495 49.072Z",
    fill: "#F6D3C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7673 34.0033C50.7673 35.0313 49.5167 36.4869 48.0811 36.0686C47.0942 35.781 45.8301 35.0313 45.8301 34.0033C45.8301 32.9748 47.2707 31.9414 48.2987 31.9414C49.9577 31.9414 50.7673 32.9748 50.7673 34.0033Z",
    fill: "#FBDED4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9043 34.7642C48.9062 34.5396 48.9431 34.3186 49.0166 34.1063C49.095 33.8949 49.1769 33.6804 49.4118 33.5035C49.4648 33.4616 49.561 33.4297 49.6452 33.4297C49.6898 33.4339 49.7393 33.4374 49.7778 33.452C49.8136 33.4701 49.8497 33.4893 49.8828 33.5123C49.9454 33.5581 49.9773 33.6135 50.0227 33.6638C50.0819 33.7499 50.0811 33.823 50.0846 33.8853C50.0861 34.1321 50.0112 34.3393 49.9162 34.5435C49.8904 34.3239 49.8774 34.099 49.8385 33.9153C49.827 33.8726 49.8093 33.8338 49.8016 33.833L49.7121 33.7599C49.6552 33.7242 49.644 33.7373 49.5844 33.7699C49.4648 33.8464 49.3476 34.0379 49.2411 34.2101C49.1361 34.3901 49.0239 34.575 48.9043 34.7642Z",
    fill: "#EEA08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1992 34.0033C26.1992 35.0313 27.4503 36.4869 28.8855 36.0686C29.8728 35.781 31.1365 35.0313 31.1365 34.0033C31.1365 32.9748 29.6959 31.9414 28.6679 31.9414C27.0089 31.9414 26.1992 32.9748 26.1992 34.0033Z",
    fill: "#FBDED4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0612 34.7642C27.942 34.575 27.8297 34.3901 27.7248 34.2101C27.6179 34.0379 27.5006 33.8464 27.3807 33.7699C27.3219 33.7373 27.3107 33.7242 27.2538 33.7599L27.1638 33.833C27.1562 33.8338 27.1385 33.8726 27.1269 33.9153C27.0881 34.099 27.075 34.3239 27.0497 34.5435C26.9543 34.3393 26.8793 34.1321 26.8809 33.8853C26.8847 33.823 26.884 33.7499 26.9428 33.6638C26.9881 33.6135 27.0201 33.5581 27.0827 33.5123C27.1158 33.4893 27.1519 33.4701 27.1877 33.452C27.2265 33.4374 27.2757 33.4339 27.3203 33.4297C27.4045 33.4297 27.5006 33.4616 27.5541 33.5035C27.789 33.6804 27.8705 33.8949 27.9489 34.1063C28.0227 34.3186 28.0593 34.5396 28.0612 34.7642Z",
    fill: "#EEA08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2917 31.326C48.4751 38.5058 45.0765 45.3684 39.1738 45.5195C33.2708 45.6702 29.0079 39.5415 28.8245 32.3617C28.6411 25.1819 32.606 19.6702 38.5087 19.5191C44.4117 19.368 48.108 24.1461 48.2917 31.326Z",
    fill: "#FBDED4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1762 31.6899C35.1666 32.0875 34.9197 32.4039 34.6256 32.397C34.3311 32.3896 34.1001 32.0617 34.1097 31.6642C34.1197 31.2666 34.3661 30.9502 34.6606 30.9571C34.9551 30.9644 35.1858 31.2928 35.1762 31.6899Z",
    fill: "#172133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8559 31.6899C42.8462 32.0875 42.5998 32.4039 42.3049 32.397C42.0108 32.3896 41.7797 32.0617 41.7894 31.6642C41.799 31.2666 42.0458 30.9502 42.3403 30.9571C42.6344 30.9644 42.8655 31.2928 42.8559 31.6899Z",
    fill: "#172133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2578 35.4492C36.6323 35.8767 37.0144 36.2685 37.432 36.5742C37.8506 36.8744 38.3051 37.0766 38.7645 37.0613C39.2251 37.0659 39.688 36.8579 40.1301 36.5807C40.5715 36.2966 40.9848 35.9348 41.4288 35.5753C41.2012 36.0986 40.8783 36.5818 40.4435 36.9832C40.2262 37.1851 39.9763 37.3573 39.6968 37.4961C39.4135 37.6249 39.0967 37.7064 38.7707 37.7149C38.445 37.7129 38.1198 37.6383 37.8353 37.5007C37.5535 37.3577 37.3012 37.1755 37.0967 36.9563C36.6826 36.5249 36.3951 36.0059 36.2578 35.4492Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1548 34.0985C38.3035 33.872 38.4835 33.6948 38.6749 33.5352C38.8641 33.373 39.0686 33.2346 39.2832 33.1112L39.2709 33.6906C39.0852 33.5498 38.9498 33.383 38.8449 33.21C38.7418 33.0351 38.663 32.859 38.6088 32.676C38.4962 32.3138 38.45 31.9413 38.4935 31.5664C38.6995 31.8794 38.8779 32.1812 39.0667 32.4587C39.1667 32.5929 39.2528 32.7317 39.3593 32.8417C39.4615 32.9539 39.5646 33.0531 39.6672 33.1193L40.0928 33.3941L39.6549 33.6986C39.4523 33.8397 39.2397 33.9655 39.0121 34.0673C38.786 34.1723 38.5488 34.2592 38.2809 34.2969C38.2101 34.3072 38.1448 34.258 38.1348 34.1873L38.1548 34.0985Z",
    fill: "#D1746F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.708 18.003C41.5727 16.2664 37.6765 17.0027 37.6765 17.0027C34.1252 17.4321 30.8908 19.4874 29.2733 22.6781C26.7847 27.5865 28.9035 32.7564 28.9035 32.7564C34.6035 30.6918 38.1798 24.3767 39.6907 21.1306C40.3635 24.3917 42.4166 28.8137 48.2988 31.9394C48.2988 31.9394 49.9701 23.0956 43.708 18.003Z",
    fill: "#0A0F21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2b7dda248ccaddb81041fec6411025eb.svg";
export { ForwardRef as ReactComponent };